import { Component } from '@angular/core';

@Component({
    selector: 'app-user-terms-31-july-2024',
    templateUrl: './user-terms-31-july-2024.component.html',
    styleUrl: './user-terms-31-july-2024.component.scss',
    standalone: false
})
export class UserTerms31July2024Component {

}
